<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Transactions</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Transactions
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Transactions</h4>
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <download-excel
                            ref="exporter-csv"
                            v-show="false"
                            type="csv"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Transactions_Report.csv'"
                        />
                        <download-excel
                            ref="exporter-xls"
                            v-show="false"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Transactions_Report.xls'"
                        />
                        <a href="#" @click.prevent="exportTableData('admin.transactions.index', {}, 'csv')" class="export-link">
                            <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                        <a href="#" @click.prevent="exportTableData('admin.transactions.index', {}, 'xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                    </div>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Payment Channel</label>
                                    <select name="category" id="category" class="form-control"
                                            v-model="filters.payment_channel">
                                        <option :value="null" :selected="filters.payment_channel==null">All</option>
                                        <option v-for="payment_channel in payment_channels" :key="payment_channel"
                                                :value="payment_channel">
                                            {{ payment_channel }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="start_date">By Start Date</label>
                                    <date-time-field id="start_date" class="form-control" v-model="filters.date_from" bound="start"></date-time-field>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="end_date">By End Date</label>
                                    <date-time-field id="end_date" class="form-control" v-model="filters.date_to" bound="end"></date-time-field>
                                </div>
                            </div>
                            <div class="col-md-4 mb-4">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allTransactions"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'image'">
                               <a :href="props.row.image" target="_blank">
                                   <img :src="props.row.image" :alt="props.row.name +' Image'"
                                        class="img-thumbnail img-fluid"
                                        style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                               </a>
                            </span>
                            <span v-else-if="props.column.field === 'is_new'">
                                <template v-if="props.row.is_new">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'is_active'">
                                <template v-if="props.row.is_active">
                                    <span class="badge badge-glow badge-success">Active</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">Inactive</span>
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#" @click.prevent="showRequeryAlert(props.row.id)" class="dropdown-item">
                                    <i class="feather icon-repeat"></i>
                                    Requery
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";
import {formatDateTime} from "../../utils";

export default {
    metaInfo: {title: 'Transactions'},
    props: [
        'transactions',
        'payment_channels',
    ],
    layout: Layout,
    name: 'TransactionIndex',
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        TableExportMixin,
    ],
    data() {
        return {
            filters: {
                payment_channel: null,
                date_from: null,
                date_to: this.getCurrentDate(),
                user_id: this.getUserId(),
            },
            isLoadingFilter: false,
            allTransactions: [],
            exportRows: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10,
                columnFilters: {},
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },
            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Transaction Reference',
                    field: 'transaction_no',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    label: 'Amount',
                    field: 'amount',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn
                },
                {
                    label: 'Payment Channel',
                    field: 'payment_channel',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    // formatFn: this.formatFn
                },
                {
                    label: 'Owner',
                    field: 'owner.first_name',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFullName
                },
                {
                    label: 'Store',
                    field: 'transactionable.store.name',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {label: 'Status', field: 'status', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Created At', field: 'created_at', thClass: 'text-center', formatFn: this.formatDate},
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
        }

    },
    computed: {
        exportFields() {
            return this.buildExportFieldsFromColumns(this.columns);
        },
    },
    mounted() {
        this.allTransactions = this.transactions.data;
        this.totalRecords = this.transactions.total;
    },

    methods: {
        async paginatedData() {
            try {
                let routeName = 'admin.transactions.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allTransactions = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        },
        formatFn(value) {
            return '₦' + (value ?? 0);
        },
        formatFullName(value, row) {
            return row.owner.first_name + " " + row.owner.last_name
        },
        formatDate(value) {
            return formatDateTime(value);

        },
        getCurrentDate() {
            const local = new Date();
            local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
            return local.toJSON().slice(0, 10);
        },
        getUserId() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('user_id') || null;
        },
        async showRequeryAlert(transactionId) {
            const details = {
                title: "Are you sure you want to requery this transaction?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text, true, "#3085d6", "#d33", "Yes, Requery")
                ? await this.requeryTransaction(transactionId)
                : "";
        },
        async requeryTransaction(transactionId) {
            this.saving = true;
            this.$inertia.patch(route('admin.transactions.requery', transactionId), {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                    this.paginatedData();
                },
                onError: () => {
                    this.saving = false;
                }
            })
        },
    }
}
</script>
